import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import { useAuth } from "../../contexts/AuthContext";
import { canAccessFeature } from "../../auth/featureScopes";
import MyCodSignatureCard from "../../components/profile/MyCodSignatureCard";

// Your own settings, reached from "Your Profile" in the avatar menu. Currently the CoD signature is
// the only thing here; it exists as a page because a signature belongs to a person, not to the
// business, and the admin CoD page is the wrong place for it.
export default function Profile() {
  const { t } = useTranslation("profile");
  const { setInfo } = usePageNameContext();
  const { forename, surname, email, featureScopes } = useAuth();

  useEffect(() => {
    setInfo({
      name: t("Your Profile"),
      desc: t("Your personal settings"),
    });
  }, []);

  // Holding a CoD signature is what "authorised to sign" means, so someone without the scope has
  // nothing to manage. The API refuses them too - this only avoids showing an empty card.
  const canSignCods = canAccessFeature(featureScopes, "cod");

  return (
    <div className="mt-4 flex flex-col gap-4">
      <section className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900">
          {[forename, surname].filter(Boolean).join(" ") || t("Your Profile")}
        </h2>
        {email && <p className="mt-1 text-sm text-gray-500">{email}</p>}
      </section>

      {canSignCods ? (
        <MyCodSignatureCard />
      ) : (
        <section className="bg-white rounded-lg shadow p-6">
          <p className="text-sm text-gray-500">
            {t("There are no personal settings to configure yet.")}
          </p>
        </section>
      )}
    </div>
  );
}
